<template>
	<div class="automatic-content">
		<el-dialog
			v-if="dialogVisible"
			title="批量设置自贩价格"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="400px"
			:before-close="cancle">
			<div>
				<el-table
					border
					height="400"
					:data="priceData"
					:header-cell-style="{
						background: 'rgba(200, 204, 215,.6)',
						color: '#333333'
					}"
					@current-change="handleCurrentChange"
				>
					<el-table-column width="60" prop="agentName" label="选择" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<el-radio v-model="priceId" :label="scope.row.priceId"><span></span></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="priceName" label="名称" :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button  size="small" @click="cancle()">取 消</el-button>
				<el-button  size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
			// 当前价格id
			priceId: null,
			// 价格列表
			priceData: [],
			// 选中客商列表
			rows: [],
		};
	},
	methods: {
		init(rows) {
			this.rows = rows;
			this.$nextTick(() => {
				// 获取价格列表
				this.$request.post(
					"getPriceList",
					true, {
						priceType: 1
					}
				)
				.then((res) => {
					if (res) {
						// 重置价格选择
						this.priceId = null;
						this.dialogVisible = true;
						this.priceData = res.data;
					}
				})
			})
		},
		// 点击价格行radio自动选中
		handleCurrentChange(currentRow, oldCurrentRow) {
			this.priceId=currentRow.priceId;
		},
		cancle() {
			this.$emit('handleBatch');
			this.dialogVisible = false;
		},
		submitForm() {
			let that = this;
			let agentIds = []
			that.rows.forEach(item => {
				agentIds.push(item.agentId)
			});
			that.$request.post(
					"agentInfoBatchUpdatePrice",
					true, {
						agentIds: agentIds,
						priceId: that.priceId
					}
				)
				.then((res) => {
					if (res.code == 0) {
						that.$message.success("设置成功！")
						this.dialogVisible = false
						this.$emit("getList")
					}
				})
		}
	}
}
</script>
<style lang="scss" scoped>
.automatic-content /deep/ .el-dialog__body {
	padding: 20px 20px 10px;
}

.el-table {
	// 深度选择器，去除默认的padding
	/deep/ th {
		padding: 0px;
		line-height: 34px;
	}

	/deep/ td {
		padding: 5px;
	}

	/deep/ .warning-row {
		background: #f1f1f5;
	}
	/deep/ th .el-table__cell {
		padding: 0 !important;
	}
}
</style>
